// @flow
import {
    CHANGE_ZONE,
    RECEIVED_NOTIFICATIONS,
    SAVE_NOTIFICATIONS,
    SAVE_NOTIFICATIONS_ERROR,
    SAVED_NOTIFICATIONS
} from './constants';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';
import handleReduce from '~/core/state/handle-reduce';

const initialState = {
    isLoading: true,
    isSaving: false,
    hasError: false,
    notifications: fromJS([])
};

export default handleActions(
    {
        [CHANGE_ZONE]: handleReduce((state, { payload }) => ({
            ...state,
            productId: payload
        })),
        [RECEIVED_NOTIFICATIONS]: handleReduce((state, { payload }) => {
            return {
                isLoading: false,
                hasError: false,
                // $FlowFixMe
                notifications: fromJS(payload)
                    .entrySeq()
                    .map(([key, item]) => item.set('id', key))
                    .toList()
            };
        }),
        [SAVE_NOTIFICATIONS]: handleReduce(state => ({ ...state, isSaving: true, hasError: false })),
        [SAVE_NOTIFICATIONS_ERROR]: handleReduce(state => ({ ...state, isSaving: false, hasError: true })),
        [SAVED_NOTIFICATIONS]: handleReduce(({ notifications, ...state }, { payload }) => {
            // $FlowFixMe
            const itemIndex = notifications.findIndex(x => x.get('id') === payload.id);

            return {
                ...state,
                isSaving: false,
                // $FlowFixMe
                notifications: notifications.set(itemIndex, fromJS(payload))
            };
        })
    },
    initialState
);



// WEBPACK FOOTER //
// ./src/core/state/notifications/index.js